interface ButtonStyles {
  TEXT: 'text';
  CONTAINED: 'contained';
  OUTLINED: 'outlined';
}

const buttonStyles: ButtonStyles = {
  // variants
  TEXT: 'text',
  CONTAINED: 'contained',
  OUTLINED: 'outlined',
};

export default buttonStyles;
